import styled from 'styled-components'
import { SubHeaderParagraph } from 'styles/typography/paragraphs'
import { Button } from 'components/Button'
import { PHONE_BREAKPOINT, TABLET_BREAKPOINT } from 'styles/breakpoints'
import { handleFontSize } from 'styles/typography'

export const AuthPageWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const AuthMain = styled.div`
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    width: 100%;
    overflow: scroll;
  }
`

export const AuthForm = styled.div`
  width: 400px;
  max-width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: auto;

  & > * + * {
    margin-top: 16px;
  }

  & > div {
    display: flex;
    flex-direction: column;
  }

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    padding: 24px;
    width: unset;
  }

  @media screen and (max-width: ${PHONE_BREAKPOINT}px) {
    padding: 10px;
  }
`

export const AuthSubHeader = styled(SubHeaderParagraph)`
  font-size: ${() => handleFontSize('xl')};
  margin-top: 28px;
  margin-bottom: 35px;
  a {
    text-decoration: underline;
  }
`

export const AuthButton = styled(Button)`
  padding-top: 19px;
  padding-bottom: 19px;
  span {
    font-size: ${() => handleFontSize('lg')};
  }
`

export const AuthSidebar = styled.div<{
  login?: boolean
}>`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  width: 40%;
  height: 100%;
  background-color: ${({ theme }) => theme.background.secondary};
  overflow: auto;
  clip-path: ellipse(60% 100% at 62% 50%);

  ::-webkit-scrollbar-thumb {
    background: transparent;
  }
  scrollbar-color: transparent transparent;

  @media screen and (max-width: ${TABLET_BREAKPOINT}px) {
    display: none;
  }
`

export const ReturnHomeLink = styled.div`
  position: absolute;
  top: 42px;
  right: 56px;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.secondary};
  border: 1px solid ${({ theme }) => theme.secondary};
  cursor: pointer;

  & > * + * {
    margin-left: 8px;
  }
`
